export enum StoreModule {
  Global = "global/",
  Lists = "lists/"
}
